import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-only
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/cn.js';
/**
 * Shimmer placeholder using the tokens `.nb-skel` sweep (surface-3 ↔
 * surface-2, 1.4s; static under reduced motion). `aria-hidden` — the loading
 * *container* carries `aria-busy`.
 */
export const skeletonVariants = cva('nb-skel block', {
    variants: {
        rounded: {
            sm: 'rounded-sm',
            md: 'rounded-md',
            lg: 'rounded-lg',
            full: 'rounded-full',
        },
    },
    defaultVariants: { rounded: 'md' },
});
function toCssSize(value) {
    if (value === undefined)
        return undefined;
    return typeof value === 'number' ? `${value}px` : value;
}
export function Skeleton({ className, rounded, width, height, ...props }) {
    return (_jsx("div", { "aria-hidden": "true", className: cn(skeletonVariants({ rounded }), width !== undefined && 'w-[var(--adm-w)]', height !== undefined && 'h-[var(--adm-h)]', className), 
        // Sanctioned escape hatch: CSS custom properties only.
        style: { '--adm-w': toCssSize(width), '--adm-h': toCssSize(height) }, ...props }));
}
//# sourceMappingURL=Skeleton.js.map